export const setFieldValueAndTouched = (fieldName, value, form) => {
  form.setFieldTouched(fieldName); // B21-23117 freeze window when name is 'wardrobe.${id}(number like), need to figure out how solve'
  form.setFieldValue(fieldName, value);
  // Timeout helps with validation when copy paste data into field
  setTimeout(() => form.validateField(fieldName));
};

export const isFieldEmptyValidationHelper = (fieldName) => (values) => {
  if (values[fieldName]) {
    return {};
  }
  return {
    [fieldName]: 'This field cant be empty!',
  };
};
